var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resume-edu-scroll"},[_c('Select',{attrs:{"selected-index":_vm.selectedIndex,"show":true,"data-list":_vm.scope},on:{"on-scrollend":_vm.handleScrollEnd}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }